import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import BrandInfo from './BrandInfo';
import FeatureProducts from './FeatureProducts';
import Footer from './Footer';
import HeroVideo from './HeroVideo';
import ShopSlider from './ShopSlider';
import css from './BrandCollabPage.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BrandCollabPage = function BrandCollabPage(_ref) {
  var brandInfo = _ref.brandInfo,
      featureProducts = _ref.featureProducts,
      footer = _ref.footer,
      heroVideo = _ref.heroVideo,
      shopSlider = _ref.shopSlider;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(HeroVideo, _objectSpread({}, heroVideo)), /*#__PURE__*/_jsx(BrandInfo, _objectSpread({}, brandInfo)), /*#__PURE__*/_jsx(FeatureProducts, _objectSpread({}, featureProducts)), /*#__PURE__*/_jsx(ShopSlider, _objectSpread({}, shopSlider)), /*#__PURE__*/_jsx(Footer, _objectSpread({}, footer))]
  });
};

BrandCollabPage.propTypes = {
  brandInfo: PropTypes.shape().isRequired,
  featureProducts: PropTypes.shape().isRequired,
  footer: PropTypes.shape().isRequired,
  heroVideo: PropTypes.shape().isRequired,
  shopSlider: PropTypes.shape().isRequired
};
export default BrandCollabPage;